module.exports = __webpack_public_path__ + "static/media/Edit.47831ac5.svg";